
























import Vue, { PropType } from "vue"
import { JobCategoryOption } from "~/clStores/projectSearchParameterOption"
import FilterDescription from "~/components/custom/search/FilterDescription.vue"

export default Vue.extend({
  components: {
    FilterDescription,
  },
  props: {
    value: {
      type: Array as PropType<number[]>,
      required: true,
    },
    options: {
      type: Array as PropType<JobCategoryOption[]>,
      required: true,
    },
  },
  methods: {
    isSelected(jobCategoryId: number): boolean {
      return this.value.includes(jobCategoryId)
    },
    handleInput(jobCategoryIds: number[]) {
      this.$emit("input", jobCategoryIds)
    },
    select(jobCategoryId: number) {
      this.handleInput(
        this.isSelected(jobCategoryId)
          ? this.value.filter((v) => v !== jobCategoryId)
          : [...this.value, jobCategoryId]
      )
    },
  },
})
